import { render } from "./page-feed.vue?vue&type=template&id=3e1cdc29"
import script from "./page-feed.js?vue&type=script&lang=js"
export * from "./page-feed.js?vue&type=script&lang=js"

import "./page-feed.vue?vue&type=style&index=0&id=3e1cdc29&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__